import { Color, MeshStandardMaterial } from "three";

export const DIM_COLOR = new Color("#808080");

// Shared materials (created once)
export const inactiveMaterial = new MeshStandardMaterial({
  color: "#808080",
  transparent: true,
  opacity: 0.02,
  depthWrite: false,
});

export const activeRoomFloorMaterial = new MeshStandardMaterial({
  color: "#f2d7a0",
  transparent: true,
  opacity: 0.8,
  depthWrite: false,
});

export const activeRoomWallMaterial = new MeshStandardMaterial({
  color: "#ffffff",
  transparent: true,
  opacity: 0.9,
  depthWrite: false,
});

export const endpointRoomFloorMaterial = new MeshStandardMaterial({
  color: "#64ffda",
  transparent: true,
  opacity: 0.8,
  depthWrite: false,
});

export const endpointRoomWallMaterial = new MeshStandardMaterial({
  color: "#ffffff",
  transparent: true,
  opacity: 0.9,
  depthWrite: false,
});

export const stairsMaterial = new MeshStandardMaterial({
  color: "#b3d9ff",
  transparent: true,
  opacity: 0.7,
  depthWrite: false,
});

export const corridorStairsMaterial = new MeshStandardMaterial({
  color: "#b3d9ff",
  transparent: true,
  opacity: 0.5,
  depthWrite: false,
});

// Material for dimmed floors (opacity = 0.05)
export const dimmedMaterial = new MeshStandardMaterial({
  color: "#808080",
  transparent: true,
  opacity: 0.05,
  depthWrite: false,
});

// Material for hidden floors (opacity = 0)
export const hiddenMaterial = new MeshStandardMaterial({
  visible: false,
});

// Overlay materials - render on top of everything (depthTest: false)
export const overlayRoomFloorMaterial = new MeshStandardMaterial({
  color: "#f2d7a0",
  transparent: true,
  opacity: 0.9,
  depthTest: false,
  depthWrite: false,
});

export const overlayRoomWallMaterial = new MeshStandardMaterial({
  color: "#ffffff",
  transparent: true,
  opacity: 0.9,
  depthTest: false,
  depthWrite: false,
});

export const overlayEndpointRoomFloorMaterial = new MeshStandardMaterial({
  color: "#64ffda",
  transparent: true,
  opacity: 0.9,
  depthTest: false,
  depthWrite: false,
});

export const overlayEndpointRoomWallMaterial = new MeshStandardMaterial({
  color: "#ffffff",
  transparent: true,
  opacity: 0.95,
  depthTest: false,
  depthWrite: false,
});

export const overlayStairsMaterial = new MeshStandardMaterial({
  color: "#b3d9ff",
  transparent: true,
  opacity: 0.8,
  depthTest: false,
  depthWrite: false,
});

// Check if material is one of the global highlight materials
export const isGlobalHighlightMaterial = (m: MeshStandardMaterial): boolean =>
  m === inactiveMaterial ||
  m === activeRoomFloorMaterial ||
  m === activeRoomWallMaterial ||
  m === endpointRoomFloorMaterial ||
  m === endpointRoomWallMaterial ||
  m === stairsMaterial ||
  m === corridorStairsMaterial ||
  m === dimmedMaterial ||
  m === hiddenMaterial ||
  m === overlayRoomFloorMaterial ||
  m === overlayRoomWallMaterial ||
  m === overlayEndpointRoomFloorMaterial ||
  m === overlayEndpointRoomWallMaterial ||
  m === overlayStairsMaterial;
